<pds-form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
  <pds-form-row grid="1-1-1-1">
    <pds-form-field label="Id do pedido">
      <input type="text" formControlName="commerceReference" placeholder="PA-00001" />
    </pds-form-field>
    <pds-form-field label="Vendedor">
      <pds-autocomplete placeholder="Nome ou CNPJ" formControlName="branch" [source]="branches$" (autocomplete)="onAutocompleteBranches($event)" />
    </pds-form-field>
    <pds-form-field label="Valor">
      <input type="text" pdsCurrencyMask placeholder="R$ 0,00" formControlName="amount" />
    </pds-form-field>
    <pds-form-field label="Data">
      <pds-range-form [interval]="30" type="text" formControlName="date" />
    </pds-form-field>
  </pds-form-row>
  <pds-form-row grid="1-1-1-1">
    <pds-form-field label="Nº NF-E">
      <input type="text" formControlName="inboundInvoiceCode" placeholder="123456789" pdsNumberMask="[{pattern: /[^0-9]/g, replace: ''}]" />
    </pds-form-field>
  </pds-form-row>
  <pds-form-actions>
    <button pdsButton="primary" (click)="clearFilters()" type="button" [disabled]="searchForm.pristine">Limpar filtros</button>
    <button pdsButton type="submit">Buscar</button>
  </pds-form-actions>
</pds-form>
